const errorHandler = {
  name: "errors",
  error: (error) => error,
};

export default errorHandler;
